<template>
<div>
  <v-btn
    block
    @click="startDialog"
    class="ma-0 grey darken-3 add-organization-btn"
    :disabled="addBtnDisabled"
  >
    <img  src="../assets/images/icon_folder_plus@2x.png" width="16"> &nbsp;
    <span >{{$t("settings.add-organization")}}</span>
  </v-btn>

  <v-dialog
    id="organization-add"
    v-model="showAddDialog"
    max-width="400px"
    persistent
  >

    <!--組織追加ダイアログ コンテンツ-->
    <v-card class="pa-2">

      <v-form
        v-model="validated"
        ref="addOrganizationForm"
        >

        <!-- 基本情報 -->
        <div class="ma-3 mb-5">
          <p>{{$t("account.basic-information")}}</p>
          <v-text-field
            :label="$t('account.organization')"
            v-model="edit.name"
            required
            :rules="[v => !!v || $t('account.vali-org-name')]"
          ></v-text-field>

          <v-text-field
            :label="$t('account.description')"
            v-model="edit.description"
          ></v-text-field>

          <v-select
            :label="$t('account.label-parent')"
            v-model="edit.parOrganization"
            :items="organizations"
            item-text="name"
            item-value="organizationId"
            :rules="[v => !!v || $t('account.vali-org-select')]"
            required
            auto
          ></v-select>

        </div>

        <!-- 連絡先 -->
        <div class="ma-3">
          <p>{{$t("account.contact")}}</p>
          <v-text-field
            :label="$t('account.incharge')"
            v-model="edit.contact"
          ></v-text-field>

          <v-text-field
            :label="$t('account.tel')"
            :rules="phoneRules"
            v-model="edit.phone"
          ></v-text-field>

          <v-text-field
            :label="$t('account.email')"
            :rules="emailRules"
            v-model="edit.email"
          ></v-text-field>
        </div>

        <v-layout justify-center>

          <v-btn
            flat
            @click.native="closeDialog"
          >
            {{$t('account.cancel')}}
          </v-btn>

          <v-btn
            color="primary"
            class="ml-4"
            @click="addOrganization"
            :disabled="btnDisable||!validated"
          >
            {{$t("account.create")}}
          </v-btn>

        </v-layout>
      </v-form>
    </v-card>

  </v-dialog>
</div>
</template>

<script>
import moment from 'moment'
import http from '@/utils/http.js'
import validate from '@/utils/validate.js'

export default {
  data () {
    return {
      addBtnDisabled: true,
      organizations: [],
      organization: [],  // 所属組織情報
      limitCreateHierarchy: 0,  // 自組織の組織作成権限
      edit: {
        parOrganization: '',
        name: '',
        contact: '',
        description: '',
        startDate: '',
        phone: '',
        email: ''
      },
      // organizations: [],
      message: '',
      submitted: false,  // submitフラグ
      showAddDialog: false,
      validated: true,
      btnDisable: false,
      // rule
      emailRules: [
        v => validate.emailFormat(v) ||
           this.$t('account.vali-email-format')
      ],
      phoneRules: [
        v => validate.phoneFormat(v) ||
           this.$t('account.vali-phone-format'),
        v => v.length <= 128 || this.$t('account.vali-phone-length')
      ]
    }
  },
  methods: {
    init () {
      // 所属組織の情報を取得
      this.getOrganization(this.$store.getters.user.organizationId)
    },
    getOrganization (organizationId) {
      http.request('get', '/service2/dashboard/api/organizations/getDetail/' + organizationId)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get organization data failed. (' + data.result + ')')
            return
          }

          this.organization = data
          this.setlimitCreateHierarchy(this.organization)
          this.addBtnDisabled = false // ボタンを使用可能にする
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    setlimitCreateHierarchy (organization) {
      this.limitCreateHierarchy = organization.master.limitCreateHierarchy - organization.master.depth
    },
    getOrganizations () {
      http.request('get', '/service2/dashboard/api/Organizations/organizationList')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get organization list failed. (' + data.result + ')')
            return
          }
          this.organizations = this.limitOrganizations(data.organizations)
          console.log(this.organizations)
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    limitOrganizations (organizations) {
      var result = []
      console.log('orgni', organizations)
      for (var key in organizations) {
        // PC組織の作成制限 - (ログインユーザーの拠点基準の階層 + PC拠点基準の階層)
        var wklimitCreateHierarchy = parseInt(this.organization.master.limitCreateHierarchy) - (parseInt(organizations[key].depth) + parseInt(this.organization.master.depth))
        if (wklimitCreateHierarchy > 0) {
          // 作成可能な組織だけリストに表示
          result.push(organizations[key])
        }
      }
      return result
    },
    addOrganization () {
      this.btnDisable = true
      const params = {
        parOrganizationId: this.edit.parOrganization,
        name: this.edit.name,
        contact: this.edit.contact,
        phone: this.edit.phone,
        email: this.edit.email,
        description: this.edit.description,
        startDate: moment().format('YYYY-MM-DD 00:00:00')
      }
      http.request('post', '/service2/dashboard/api/Organizations/register', params)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            if (data.result === -2) {
              this.$emit('child-action', 'error', this.$t('organizations.vali-create-limit'))
            } else {
              console.log('add organization data failed. (' + data.result + ')')
              this.$emit('child-action', 'error', data.result)
            }

            this.btnDisable = false
            return
          }
          this.$emit('child-action', 'success', 'success!')
          this.$refs.addOrganizationForm.reset()
          // ダイアログ非表示
          this.btnDisable = false
          this.showAddDialog = false
          this.$router.push('/settings/organizations_detail')
        })
        .catch(error => {
          console.log('error', error)
          this.$emit('child-action', 'error', error)
          if (error.response.status === 403) {
            this.$emit('child-action', 'error', this.$store.getters.message.message)
          } else {
            this.$emit('child-action', 'error', error)
          }
          this.btnDisable = false
        })
    },
    startDialog () {
      // 組織作成制御
      if (this.limitCreateHierarchy === 0) {
        this.$emit('child-action', 'error', this.$t('organizations.vali-create-limit'))
        return
      }
      this.getOrganizations()
      this.showAddDialog = true
    },
    closeDialog () {
      this.$refs.addOrganizationForm.reset()
      this.btnDisable = false
      this.showAddDialog = false
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>
.dialog__container {
  width: 100%;
}

.add-organization-btn .btn__content {
  justify-content: left;
  color:white;
}

</style>



// WEBPACK FOOTER //
// AccountOrganizationAdd.vue?f4ea6b52